import * as React from 'react'
import { ReactElement } from 'react'
import { LineItemProps } from './LineItem'
import { DisbursementListItemDto } from '../../../../../config/registrationConfig'
import { Stack, Text } from '@fluentui/react'
import { Badge } from '@fluentui/react-components'
import { MailInboxRegular } from '@fluentui/react-icons'
import { formatShortDate } from '../../../../../helpers/dateHelper'
import useVatType from '../../../../../hooks/useVatType'

export default function DisbursementLineItem({ entity }: LineItemProps<DisbursementListItemDto>): ReactElement {
    const { vatTypeName } = useVatType(entity.vatType)

    return (
        <Stack horizontal={false} verticalAlign="center" tokens={{ childrenGap: 's2 s1', padding: 's2 0' }} wrap>
            <Text>{entity.description}</Text>
            <Stack horizontal tokens={{ childrenGap: 's2' }}>
                <Badge size="medium" icon={<MailInboxRegular />} appearance="tint">
                    {formatShortDate(entity.date)}
                </Badge>
                <Badge size="medium" appearance="tint">
                    {vatTypeName}
                </Badge>
            </Stack>
        </Stack>
    )
}
